import Swiper from '../../common/custom-swiper/custom-swiper';

export default new class throughSlider {
  constructor() {
    this.sliderPanelSelector = 'through-slider__panel';
    this.sliderListSelector = 'through-slider__item';
    this.sliderListCodeAttribute = 'data-slider-id';
    this.sliderListCloseSelector = 'through-slider__close';

    this.cookieThroughSlider = 'through-slider';
    this.removeDelay = 500;

    this.sliderContainerSelector = 'through-slider__container';
    this.slideSelector = 'through-slider__item';

    this.pagination = {
      el: '.main-slider__pagination',
      lockClass: 'main-slider__pagination_disable',
      type: 'fraction',
    };
    this.navigation = {
      nextEl: '.main-slider__btn_next',
      prevEl: '.main-slider__btn_prev',
      disabledClass: 'main-slider__btn_disable',
      hiddenClass: 'main-slider__btn_hidden',
    };

    this.init();
  }

  init() {
    $.request('AlertList::onGetAlert', {
      data: {
        type: 'banner',
      },
      complete: (res) => {
        this.createSlider(res.responseJSON);
      },
    });
  }

  createSlider(res) {
    const arAlertList = res.data;
    $.request('onAjax', {
      data: {
        arAlertList,
      },
      update: {
        'content/through-slider/through-slider-ajax': `.${this.sliderPanelSelector}`,
      },
      complete: () => {
        this.initSlider();
        this.close();
      },
    });
  }

  close() {
    $(document).on('click', `.${this.sliderListCloseSelector}`, (e) => {
      const sliderCode = e.currentTarget.getAttribute(this.sliderListCodeAttribute);

      if (sliderCode) {
        $.request('AlertList::onCloseAlert', {
          data: {
            code: sliderCode,
          },
          complete: () => {
            this.init();
          },
        });
      }
    });
  }

  initSlider() {
    const slider = document.querySelector(`.${this.sliderContainerSelector}`);

    if (!slider) return;

    const slides = slider.querySelectorAll(`.${this.slideSelector}`).length;

    // eslint-disable-next-line no-new
    new Swiper(`.${this.sliderContainerSelector}`, {
      spaceBetween: 0,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      loop: slides > 1,
    });
  }
}();
